import { render, staticRenderFns } from "./ozone.vue?vue&type=template&id=aa4eaeec&scoped=true"
import script from "./ozone.vue?vue&type=script&lang=js"
export * from "./ozone.vue?vue&type=script&lang=js"
import style0 from "./ozone.vue?vue&type=style&index=0&id=aa4eaeec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4eaeec",
  null
  
)

export default component.exports